import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import "../MasterFormStyles.scss";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import addIcon from "../../../Assets/addWhiteIcon.png";
import MasterAddUpdateForm from "../MasterAddUpdateForm/MasterAddUpdateForm";
import { Divider } from "primereact/divider";
import ModalHeader from "../../../Components/Header/ModalHeader";
import {
  getTableMasterData,
  getIsMasterDataLoading,
  getAddedData,
  getValidateMasterData,
  getPaginationMasterData,
} from "../../../Store/Masters/MastersSelectors";
import { fetchMasterData } from "../../../Store/Masters/MastersAction";
import AppCustomTable from "../../../Shared/Component/CustomTable/AppCustomTable";
import UpdateButton from "./UpdateButton";
import { FORM_MODE } from "../../../Shared/Constant/MasterFormConstants";
import { DeleteButton } from "./DeleteButton";
import UserRoles from "../../../Shared/Constant/UserRoles";
import { getMasterDataServiceById } from "../../../Services/MasterService";
import { useTranslation } from "react-i18next";
import { useLanguage } from "../../ChangeLanguage/LanguageProvider";
const MasterTableView = (props) => {
  const { formConfig, masterType, viewConfig } = props;
  const { tableConfig, showAddButton, showUpdateButton } = viewConfig;
  const { title } = formConfig;
  const [enableFileDocument, setEnableFileDocument] = useState();
  const { t } = useTranslation("master");
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const currentRole = sessionStorage.getItem("userRole");
  const { selectedLanguageId } = useLanguage();
  const filteredColumns = [UserRoles.ADMIN, UserRoles.SUPERADMIN].includes(
    currentRole
  )
    ? tableConfig.columns
    : tableConfig.columns.filter(
        (column) =>
          !["Select", "Status", "Approved By", "Approved Date & Time"].includes(
            column.header
          )
      );
  const dispatch = useDispatch();
  const isApiLoading = useSelector(getIsMasterDataLoading);
  const validateMasterData = useSelector(getValidateMasterData);
  const addedData = useSelector(getAddedData);
  const masterData = useSelector(getTableMasterData);
  const paginationData = useSelector(getPaginationMasterData);
  const [data, setData] = useState([]);
  const [formMode, setFormMode] = useState(FORM_MODE.ADD);
  const [selectedItems, setSelectedItems] = useState([]);
  const [visible, setVisible] = useState(false);
  const [initialTranslateValue, setInitialTranslateValue] = useState();
  const [filters, setFilters] = useState({});

  const clearSelection = () => {
    setFormMode("Add");
    setSelectedItems([]);
  };

  const closeDialog = () => {
    clearSelection();
    setVisible(false);
  };

  const Add = () => {
    setEnableFileDocument(true);
    setFormMode("Add");
    setVisible(true);
  };

  useEffect(() => {
    dispatch(fetchMasterData(masterType, selectedLanguageId, page, pageSize, filters));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addedData, validateMasterData, selectedLanguageId, page, pageSize, filters]);

  useEffect(() => {
    setData(masterData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [masterData]);

  const showCrudButtons = (roleOption) =>
    roleOption.length > 0 && roleOption.includes(currentRole);

  useEffect(() => {
    if (selectedItems && selectedItems.length === 1) {
      getMasterDataServiceById(
        selectedItems[0][tableConfig.dataKey],
        masterType
      )
        .then((data) => {
          setInitialTranslateValue(data);
        })
        .catch(() => {
          setInitialTranslateValue({});
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedItems, masterType]);

   const handleTablePageChange = (newPage, newPageSize) => {
    setPage(newPage);
    setPageSize(newPageSize);
  };
  return (
    <>
      <div className="masterScreen">
        <div className="grid flex justify-content-end mb-2">
          <div className=" md:col-6 col-div"></div>
          <div className="sm:col-12 md:col-6 button_section">
            <div className="grid align-items-center justify-content-end">
              <div className="flex sm:col-12 sm:text-center justify-content-end gap-2 md:col pr-0">
                <UpdateButton
                  setVisible={setVisible}
                  setFormMode={setFormMode}
                  currentRole={currentRole}
                  selectedItems={selectedItems}
                  showButton={showUpdateButton}
                  formConfig={formConfig}
                  enableFileDocument={false}
                  setEnableFileDocument={setEnableFileDocument}
                />
                <DeleteButton
                  selectedItems={selectedItems}
                  setSelectedItems={setSelectedItems}
                  currentRole={currentRole}
                  title={title}
                  masterType={masterType}
                  viewConfig={viewConfig}
                />
              </div>
              {showCrudButtons(showAddButton) && (
                <>
                  <div className="divider-layout ">
                    <Divider layout="vertical" />
                  </div>
                  <div className="flex sm:col-12 w-auto sm:text-center md:col-5 ">
                    <Button
                      data-testid="add-district-data"
                      className="btn btn-primary-filled"
                      onClick={Add}
                      label={`${t("AddNew")} ${t(title)}`}
                      icon={<img src={addIcon} alt="Add icon" />}
                      disabled={selectedItems.length > 0 || data.length === 0}
                      tooltip={`Add ${title} data`}
                      tooltipOptions={{ position: "bottom", event: "both" }}
                    />
                  </div>
                </>
              )}
            </div>
          </div>
        </div>

        <AppCustomTable
          columns={filteredColumns}
          data={data}
          isApiLoading={isApiLoading}
          dataKey={tableConfig.dataKey}
          selectedItems={selectedItems}
          onSelectionChange={(e) => setSelectedItems(e.value)}
          filterMethodsConfig={tableConfig.filterMethodsConfig}
          page={page}
          pageSize={pageSize}
          onPageChange={handleTablePageChange}
          totalCount={paginationData?.totalCount}
          onFilterChange={(newFilters) => {
            setFilters((prevFilters) => {
              const mergedFilters = { ...prevFilters, ...newFilters };
              Object.keys(mergedFilters).forEach((key) => {
                if (!mergedFilters[key]) {
                  delete mergedFilters[key];
                }
              });
              return mergedFilters;
            });
            setPage(1);
          }}
        />
      </div>
      <Dialog
        className="cockpit-dialog"
        visible={visible}
        modal={true}
        position={"center"}
        draggable={false}
        resizable={false}
        onHide={closeDialog}
        closeOnEscape={false}
        header={
          <ModalHeader onClose={closeDialog} backText={t("Back To Master")} />
        }
      >
        <MasterAddUpdateForm
          data-testid="show-dialog"
          mode={formMode}
          selectedItems={selectedItems.map(({ attachedDoc, ...rest }) => rest)}
          onClose={closeDialog}
          setSelectedItems={setSelectedItems}
          formConfig={formConfig}
          masterType={masterType}
          enableFileDocument={enableFileDocument}
          initialValues={{
            ...(() => {
              const { attachedDoc, ...rest } = selectedItems[0] || {};
              return rest;
            })(),
            ...{ stateName: "Maharashtra" },
          }}
          initialTranslatedValue={initialTranslateValue}
        />
      </Dialog>
    </>
  );
};
export default MasterTableView;
